export const PHARMACY_LOCAL = {
	CLOSED: 'CERRADO',
	SCHEDULE_DAYS: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
	TIME: [
		{
			label: 'Cerrado',
			value: 'CERRADO',
		},
		{
			label: '00:00:00',
			value: '00:00:00',
		},
		{
			label: '00:30:00',
			value: '00:30:00',
		},
		{
			label: '01:00:00',
			value: '01:00:00',
		},
		{
			label: '01:30:00',
			value: '01:30:00',
		},
		{
			label: '02:00:00',
			value: '02:00:00',
		},
		{
			label: '02:30:00',
			value: '02:30:00',
		},
		{
			label: '03:00:00',
			value: '03:00:00',
		},
		{
			label: '03:30:00',
			value: '03:30:00',
		},
		{
			label: '04:00:00',
			value: '04:00:00',
		},
		{
			label: '04:30:00',
			value: '04:30:00',
		},
		{
			label: '05:00:00',
			value: '05:00:00',
		},
		{
			label: '05:30:00',
			value: '05:30:00',
		},
		{
			label: '06:00:00',
			value: '06:00:00',
		},
		{
			label: '06:30:00',
			value: '06:30:00',
		},
		{
			label: '07:00:00',
			value: '07:00:00',
		},
		{
			label: '07:30:00',
			value: '07:30:00',
		},
		{
			label: '08:00:00',
			value: '08:00:00',
		},
		{
			label: '08:30:00',
			value: '08:30:00',
		},
		{
			label: '09:00:00',
			value: '09:00:00',
		},
		{
			label: '09:30:00',
			value: '09:30:00',
		},
		{
			label: '10:00:00',
			value: '10:00:00',
		},
		{
			label: '10:30:00',
			value: '10:30:00',
		},
		{
			label: '11:00:00',
			value: '11:00:00',
		},
		{
			label: '11:30:00',
			value: '11:30:00',
		},
		{
			label: '12:00:00',
			value: '12:00:00',
		},
		{
			label: '12:30:00',
			value: '12:30:00',
		},
		{
			label: '13:00:00',
			value: '13:00:00',
		},
		{
			label: '13:30:00',
			value: '13:30:00',
		},
		{
			label: '14:00:00',
			value: '14:00:00',
		},
		{
			label: '14:30:00',
			value: '14:30:00',
		},
		{
			label: '15:00:00',
			value: '15:00:00',
		},
		{
			label: '15:30:00',
			value: '15:30:00',
		},
		{
			label: '16:00:00',
			value: '16:00:00',
		},
		{
			label: '16:30:00',
			value: '16:30:00',
		},
		{
			label: '17:00:00',
			value: '17:00:00',
		},
		{
			label: '17:30:00',
			value: '17:30:00',
		},
		{
			label: '18:00:00',
			value: '18:00:00',
		},
		{
			label: '18:30:00',
			value: '18:30:00',
		},
		{
			label: '19:00:00',
			value: '19:00:00',
		},
		{
			label: '19:30:00',
			value: '19:30:00',
		},
		{
			label: '20:00:00',
			value: '20:00:00',
		},
		{
			label: '20:30:00',
			value: '20:30:00',
		},
		{
			label: '21:00:00',
			value: '21:00:00',
		},
		{
			label: '21:30:00',
			value: '21:30:00',
		},
		{
			label: '22:00:00',
			value: '22:00:00',
		},
		{
			label: '22:30:00',
			value: '22:30:00',
		},
		{
			label: '23:00:00',
			value: '23:00:00',
		},
		{
			label: '23:30:00',
			value: '23:30:00',
		},
	],

	MOTIVE: ['Cambio de Horario','Farmacia de turno','Cerrado por vacaciones', 'Cerrado por feriado', 'Cerrado por duelo', 'Cerrado'] 
};
